// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"9f4d5c9c","598":"7728fa9e","787":"7b8f074f"}[chunkId] + ".chunk.js";
};